import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {AuthService} from "../../../shared/services/auth.service";
import {CouponGridService} from "../../../shared/services/coupon-grid.service";

import { properties } from '../../../../environments/properties';


declare let $: any;

@Component({
    selector: 'app-coupon-item',
    templateUrl: './coupon-item.component.html',
    styleUrls: ['./coupon-item.component.scss']
})
export class CouponItemComponent implements OnInit {

    properties = properties;

    public isWWW: boolean = true;
    public showLoadingCoupon: boolean = false;
    public clippedLabel: any;
    public clipCouponLabel: any;
    public sm = '575px';
    public md = '768px';
    public couponDetailPath: string;
    public domain: string;
    userInfo: any;
    public imagePath: string = window['AB']['dMTProductCard'];

    constructor(public authService: AuthService,
                private activeRoute: ActivatedRoute,
                public couponGridService: CouponGridService) {
    }

    public _coupon: any;

    get coupon(): any {
        return this._coupon;
    }

    @Input('data')
    set coupon(coupon: any) {

        let trimBrandAt: number = 40;
        let trimDescriptionAt: number = 60;

        coupon['updBtnText'] = (typeof coupon['updBtnText'] == 'undefined') ? this.properties.confirmation.ADDED : coupon['updBtnText'];
        coupon['updBtnMode'] = (typeof coupon['updBtnMode'] == 'undefined') ? true : coupon['updBtnMode'];
        coupon['usageTypeTxt'] = window['SWY'].CONFIGSERVICE.nimbusConfig.offerTypes[coupon['usageType']];
        coupon['couponID'] = (typeof coupon['couponID'] == 'undefined') ? coupon['offerId'] : coupon['couponID'];
        coupon['brand'] = (typeof coupon['brand'] == 'undefined') ? coupon['name'] : coupon['brand'];
        coupon['image'] = coupon['image'] ? coupon['image'] : window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon['imageId'];
        coupon['newOfferPrice'] = this.getCardHeader(coupon);

        let trimmedBrand = coupon.brand.substr(0, trimBrandAt);
        trimmedBrand = trimmedBrand.substr(0, Math.min(trimmedBrand.length, trimmedBrand.lastIndexOf(" ")));
        let trimmedDescription = coupon.description.substr(0, trimDescriptionAt);
        trimmedDescription = trimmedDescription.substr(0, Math.min(trimmedDescription.length, trimmedDescription.lastIndexOf(" ")));

        coupon.refineBrand = (coupon.brand.length > trimBrandAt) ? (trimmedBrand + '...') : (coupon.brand + '');
        coupon.refineDescription = (coupon.description.length > trimDescriptionAt) ? (trimmedDescription + '...') : (coupon.description.trim().slice(-1) == ".") ? coupon.description : (coupon.description + '.');

        this._coupon = coupon;
        this._coupon.endDate = this.dateConversion(this._coupon.endDate);
    }

    ngOnInit(): void {
        this.initCouponConfig();
        this.checkDomainPath();
        this.updateCoupon();
    }


    public getCardHeader(coupon) {
      let cardHeader = '';

      if (coupon?.forUDescription) {
        return coupon.forUDescription;
      }

      if (coupon && coupon['offerPrice'] && coupon['offerPrice'] !== '') {
        cardHeader = coupon['offerPrice']
      }

      if (coupon && coupon['priceTitle']) {
        cardHeader = coupon['priceTitle'] + ' ' + cardHeader
      }
      return cardHeader;
    }

    initCouponConfig() {
        if (window['AB']) {
            this.isWWW = window['AB'].isWWW;
        }
        if (window['SWY']) {
            this.clipCouponLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CLC'];
            this.clippedLabel = window['SWY'].CONFIGSERVICE.nimbusConfig.couponActionTypes['CLD'];
        }
    }

    updateCoupon() {
        this.couponGridService.couponUpdated.subscribe((update: any) => {
            if (this._coupon === update.id) {
                this._coupon.status = update.status;
                this._coupon.deleted = update.deleted;
                this.coupon = this._coupon;
            }
        })
    }

    checkDomainPath() {
        this.domain = this.authService.getApplicationDomainURL();
        if (window.location.href.indexOf('shop') == -1) {
            this.couponDetailPath = '/foru/offer-details';
        } else {
            this.couponDetailPath = '/offer-details';
        }
    }

    public clipCoupon(): void {
        this.activeRoute.data.subscribe(data => {
                let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
                if (isSessionValid) {
                    const sessionData = {...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN']};
                    if (sessionData) {
                        this.j4uClipCoupon(sessionData);
                    }
                } else {
                    let strError = this.properties.confirmation.COUPON_CLIP_SESSION_IS_EXPIRED_RELOADING_THE_PAGE;
                    console.error(strError)
                    this.authService.redirectToSSO(data.tokenObject)
                }
            },
            (err => {
                let strError = this.properties.confirmation.COUPON_CLIP_SESSION_IS_EXPIRED_RELOADING_THE_PAGE;
                console.error(strError)
                this.authService.redirectToSSO({});
            }));
    }

    public getImageUrl(viewport: string): string {

        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', this.coupon.imageId).replace('${viewport}', viewport) : '';
    }

    public dateConversion(dateServer: string): string {
        let dateStr = dateServer;
        if (dateStr.indexOf('/') !== -1) {
            return dateStr;
        }
        let regex = /\d+/;
        let mills = regex.exec(dateStr);
        let d = new Date(parseInt(mills[0]));
        d.setUTCMilliseconds(mills.index);
        let dateOutput = d.toLocaleDateString("en-US");
        return dateOutput;
    }

    private j4uClipCoupon(userInfo) {
        this.showLoadingCoupon = true;
        this.couponGridService.clipCoupon(this._coupon, userInfo)
            .pipe(
                finalize(() => {
                    this.showLoadingCoupon = false;
                })
            )
            .subscribe(response => {
                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                    setTimeout(() => {
                        $('#clippedCouponGrid' + this._coupon.offerId).attr('tabindex', -1).focus();
                    }, 600);
                }
            });
    }
}
